import { useNavigate } from 'react-router';
import { Button, Card, EmptyState } from '@mgdlead/ui';
import { Compass } from 'lucide-react';

import { BrandMark } from '@mgdlead/ui';
import { useDocumentTitle } from '../lib/useDocumentTitle';

/** 404 do produto — não a tela branca do servidor. */
export function NotFoundPage() {
  useDocumentTitle('Página não encontrada');
  const navigate = useNavigate();

  return (
    <div className="flex min-h-dvh flex-col items-center justify-center gap-4 bg-background px-4 py-8 text-foreground">
      <BrandMark />
      <Card padded={false} className="w-full max-w-md">
        <EmptyState
          kind="no-data"
          icon={Compass}
          title="Página não encontrada"
          description="O endereço não existe, mudou de lugar ou você não tem acesso a ele."
          action={
            <Button variant="primary" block onClick={() => void navigate('/', { replace: true })}>
              Voltar ao início
            </Button>
          }
        />
      </Card>
    </div>
  );
}
